import { useNavigate } from "react-router-dom";
import uiStyles from "../theme/uiStyles";

export default function PrivacyPolicy() {
  const nav = useNavigate();

  return (
    <div style={uiStyles.page}>
      <div style={{ ...uiStyles.card, ...styles.card }}>
        <button
          type="button"
          onClick={() => nav("/home")}
          style={styles.homeBtn}
        >
          Home
        </button>

        <div style={styles.headerRow}>
          <h1 style={styles.title}>Privacy Policy for NextBite</h1>
        </div>
        <p style={styles.updated}>
          <strong>Last updated:</strong> April 23, 2026
        </p>

        <section style={styles.section}>
          <h2 style={styles.heading}>1. Introduction</h2>
          <p>
            NextBite ("we", "our", or "us") respects your privacy. This Privacy
            Policy explains how we handle information when you use our mobile or
            web application.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>2. Information We Collect</h2>
          <p>We aim to collect as little personal information as possible.</p>
          <h3 style={styles.subheading}>a. Information You Provide</h3>
          <ul style={styles.list}>
            <li>Food entries (e.g., what your child ate)</li>
            <li>Custom inputs (e.g., typed foods, preferences)</li>
          </ul>
          <h3 style={styles.subheading}>b. Automatically Collected Information</h3>
          <p>We may collect limited technical data such as:</p>
          <ul style={styles.list}>
            <li>Device type</li>
            <li>App usage data (for improving features)</li>
          </ul>
          <p>We do not collect sensitive personal data such as:</p>
          <ul style={styles.list}>
            <li>Names</li>
            <li>Addresses</li>
            <li>Contact details unless explicitly added in future features.</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>3. How We Use Information</h2>
          <p>We use collected data to:</p>
          <ul style={styles.list}>
            <li>Provide food suggestions</li>
            <li>Improve app experience</li>
            <li>Enhance recommendations</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>4. Data Storage</h2>
          <ul style={styles.list}>
            <li>Data may be stored locally on your device</li>
            <li>Future versions may include secure cloud storage</li>
          </ul>
          <p>We do not sell or share your data with third parties.</p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>5. Children&apos;s Privacy</h2>
          <p>
            NextBite is designed for parents and caregivers. We do not knowingly
            collect personal information from children.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>6. Third-Party Services</h2>
          <p>
            We may use third-party tools (such as analytics or hosting
            services) that may collect anonymized usage data.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>7. Your Choices</h2>
          <p>You can:</p>
          <ul style={styles.list}>
            <li>Clear app data anytime</li>
            <li>Stop using the app to discontinue data collection</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>8. Security</h2>
          <p>
            We take reasonable measures to protect your information, though no
            system is completely secure.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>9. Changes to This Policy</h2>
          <p>
            We may update this policy. Updates will be reflected with a new
            "Last updated" date.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>10. Contact</h2>
          <p>If you have questions or privacy-related requests, please use our feedback form.</p>
          <button
            type="button"
            onClick={() => nav("/feedback")}
            style={styles.feedbackLink}
          >
            Open Feedback Form
          </button>
        </section>
      </div>
    </div>
  );
}

const styles = {
  card: {
    position: "relative"
  },
  headerRow: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    paddingRight: 110
  },
  title: {
    marginTop: 0,
    marginBottom: 12
  },
  updated: {
    marginTop: 0,
    color: "#475569"
  },
  section: {
    marginTop: 24
  },
  heading: {
    marginBottom: 8
  },
  subheading: {
    marginTop: 16,
    marginBottom: 8,
    fontSize: 16
  },
  list: {
    paddingLeft: 20,
    lineHeight: 1.7
  },
  feedbackLink: {
    border: "none",
    background: "transparent",
    padding: 0,
    color: "#2563eb",
    cursor: "pointer",
    fontSize: 15,
    textDecoration: "underline"
  },
  homeBtn: {
    position: "absolute",
    top: 18,
    right: 18,
    padding: "10px 16px",
    borderRadius: 999,
    border: "1px solid #f0d9d1",
    background: "rgba(255,255,255,0.85)",
    color: "#7c3d2e",
    cursor: "pointer",
    fontSize: 14,
    fontWeight: 600
  }
};
